

<ion-grid  style="height: 85%;">
  <ion-row>
  <ion-col>
    <ion-grid>
      <ion-row>
        <ion-col>
          <iframe id=monerisFrame [src]="source" frameborder='0' width="100%" height="245px"></iframe>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-item *ngFor="let message of messages">
            <ion-label class="ion-text-wrap" color="danger">{{message}}</ion-label>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-col>
  </ion-row>

</ion-grid>






<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col size="10" offset="1">
          <ion-button *ngIf="buttonLoading==false" color="primary" expand="block" (click)="doMonerisSubmit()"> {{ ('keys.data.payments.add_payment_method' | translate : {Default:'Add Payment Method'}) ||
            'Add Payment Method' }}</ion-button>
            <ion-button *ngIf="buttonLoading==true" disabled=true color="primary" expand="block" > <ion-spinner  style="--color: white"></ion-spinner></ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
   
  </ion-toolbar>
</ion-footer>


                